import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import TourVirtualAcessInfoIcon from '@/svg-icons/TourVirtualAcessInfo';

const TourAccessInfo = ({ data }) => {
  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <TourVirtualAcessInfoIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="tourAccessInfo" />
      </div>

      <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        {data.login && (
          <div className="flex flex-col mb-[1vw]" data-cy="order-details-tour-access-login">
            <div className="font-bold">
              <FormattedMessage id="login" />
            </div>
            {data.login}
          </div>
        )}
        {data.password && (
          <div className="flex flex-col" data-cy="order-details-tour-access-password">
            <div className="font-bold">
              <FormattedMessage id="password" />
            </div>
            {data.password}
          </div>
        )}
      </div>
    </div>
  );
};

TourAccessInfo.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TourAccessInfo;
